module.exports = __webpack_public_path__ + "img/change-equipment.68557bcc.svg";